<template>
  <div v-if="product !== null" class="productTile hasTextCentered">
    <div class="productTile__wrapper">
      <div class="productTile__imageWrapper">
        <MediaImage
          :filename="product.image.fileName"
          :alt="product.image.alt"
          :resolutions="product.image.resolutions"
          :fallback-size="product.image.fallbackSize"
          :sizes="product.image.sizes"
          :aria-hidden="true"
          :format="product.image.format"
        >
        </MediaImage>
      </div>
      <div class="productTile__infoWrapper">
        <p class="productTile__brandName">{{ product.brand }}</p>
        <p class="productTile__productName">{{ product.name }}</p>
      </div>
    </div>
    <div class="productTile__ratings">
      <template v-if="product.ratingActivated">
        <div class="ratingsList">
          <OapRating :rating="product.rating" />
        </div>
      </template>
    </div>
    <div class="productTile__priceWrapper">
      <p class="productTile__price">
        <a :href="product.url" target="_blank">{{ product.label }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import MediaImage from '../../../../MediaImage/code/Scripts/components/MediaImage.vue';
import OapRating from '../../../../OapRating/code/Scripts/components/OapRating.vue';

export default {
  name: 'HaircolorTreatProductTile',

  components: {
    MediaImage,
    OapRating,
  },

  props: {
    product: { type: Object },
  },

  settings: {
    ratings: 5,
  },
};
</script>
